module.exports = __webpack_public_path__ + "static/media/eye-evil.347d337d.svg";